import { AssignmentRuleResponse } from '../../responses/assignments/AssignmentRuleResponse';

export interface PermissionViewModel {
  userEmail: string;
  ruleName: string;
  ruleInternalName: string;
  permLevelName: string;
  id: string;
  displayUsername: string;
  isSelected?: boolean;
}

export function mapToViewModel(dto: AssignmentRuleResponse, index: number): PermissionViewModel {
  const username = dto.userEmail.split('@')[0];

  return {
    userEmail: dto.userEmail,
    ruleName: dto.ruleName,
    ruleInternalName: dto.ruleInternalName,
    permLevelName: dto.permLevelName,

    id: `${dto.userEmail}-${dto.ruleInternalName}-${index}`,
    displayUsername: username,
    isSelected: false
  };
}
